import Link from '@/a2ui/router/link';

export default function A2UINotFoundPage() {
  return (
    <main className="grid min-h-screen place-items-center bg-[#f6f3ec] px-4 text-[#221d17]">
      <section className="max-w-md rounded-[20px] border border-[#e7ddd2] bg-white p-6 text-center shadow-[0_8px_24px_rgba(32,24,12,0.06)]">
        <p className="text-[12px] font-medium uppercase tracking-[0.2em] text-[#9a8f84]">404</p>
        <h1 className="mt-3 text-2xl font-semibold tracking-[-0.03em]">Page not found</h1>
        <p className="mt-3 text-[14px] leading-6 text-[#6f655b]">This A2UI workbench route does not exist.</p>
        <Link href="/" className="mt-5 inline-flex text-[13px] font-medium text-[#EE5C2A]">
          Back home
        </Link>
      </section>
    </main>
  );
}
